module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"success":"成功しました。","fail":"エラーが発生しました。"}}')
  delete Component.options._Ctor
}
